const instancePrefix = (): string => {
  if (typeof window === 'undefined') return '';
  const match = window.location.pathname.match(/^\/i\/[^/]+/);
  return match ? match[0] : '';
};

export function notificationsListPath(): string {
  return `${instancePrefix()}/notifications`;
}
